import { Button, ButtonProps, CircularProgress, Box } from '@mui/material';

// ===========================================
// LoadingButton - Button with integrated loading state
// Matches existing patterns exactly
// ===========================================

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
  showExternalSpinner?: boolean;
  spinnerSize?: string | number;
  spinnerColor?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'inherit';
}

export function LoadingButton({
  loading = false,
  loadingText,
  showExternalSpinner = false,
  spinnerSize = '1.3rem',
  spinnerColor = 'info',
  children,
  disabled,
  ...props
}: LoadingButtonProps) {
  // Pattern 1: Simple text change (matches existing pattern exactly)
  const buttonContent = loading && loadingText ? loadingText : children;

  if (showExternalSpinner) {
    // Pattern 2: Button + external CircularProgress (matches grantee page pattern)
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {}
        <Button {...props} disabled={disabled || loading}>
          {buttonContent}
        </Button>
        {loading && (
          <CircularProgress
            color={spinnerColor}
            size={spinnerSize}
            style={{ marginLeft: '8px' }}
          />
        )}
      </Box>
    );
  }

  // Pattern 1: Simple button with text change
  return (
    <Button {...props} disabled={disabled || loading}>
      {buttonContent}
    </Button>
  );
}
